if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}

/* ============================================================
   One menu open at a time, anywhere.
   Opening any menu (desktop nav dropdown, filter dropdown, or
   the sort dropdown) closes every other open one. Delegated on
   document (capture) so it also covers facets re-rendered after
   filtering. Add a selector here to extend to a new menu type.
   ============================================================ */
var BK_MENU_SELECTOR = 'details.facets__disclosure[open], details.bk-sort[open], header-menu > details[open]';
function bkIsMenu(d) {
  return (
    d instanceof HTMLDetailsElement &&
    (d.classList.contains('facets__disclosure') ||
      d.classList.contains('bk-sort') ||
      (d.parentElement && d.parentElement.tagName === 'HEADER-MENU'))
  );
}
document.addEventListener(
  'toggle',
  function (event) {
    var d = event.target;
    if (!d.open || !bkIsMenu(d)) return;
    document.querySelectorAll(BK_MENU_SELECTOR).forEach(function (other) {
      if (other !== d) other.removeAttribute('open');
    });
  },
  true
);

/* Reflect the "X selected" filter counter instantly on check/uncheck. */
document.addEventListener('change', function (event) {
  var input = event.target;
  if (!input || input.type !== 'checkbox') return;
  var group = input.closest('.facets__disclosure, .facets__disclosure-vertical');
  if (!group) return;
  var count = group.querySelectorAll('input[type="checkbox"]:checked').length;
  group.querySelectorAll('.facets__header .facets__selected').forEach(function (el) {
    el.textContent = count + ' selected';
  });
  group.querySelectorAll('.facets__summary .facets__selected').forEach(function (el) {
    el.textContent = '(' + count + ')';
    el.classList.toggle('hidden', count === 0);
  });
});

/* ============================================================
   Custom sort dropdown.
   Options are <a> (same element the Category dropdown uses) so
   the rendering matches; they drive the hidden native <select>.
   The observer watches the document because Dawn's filter re-render
   swaps out a large chunk of the page (incl. the facets/sort), so a
   narrower root would detach; the callback is rAF-debounced and the
   work is a cheap querySelectorAll, so cost is negligible.
   ============================================================ */
(function () {
  function enhance(select) {
    if (select.dataset.bkSort) return;
    select.dataset.bkSort = '1';
    select.classList.add('bk-sort__native');

    var field = select.closest('.facet-filters__field') || select.parentNode;
    var fieldLabel = field.querySelector('.facet-filters__label');
    if (fieldLabel) {
      var inner = fieldLabel.querySelector('label') || fieldLabel;
      inner.textContent = (inner.textContent || '').replace(/[\s:：—-]+$/, '') + ' —';
    }

    var details = document.createElement('details');
    details.className = 'bk-sort';

    var summary = document.createElement('summary');
    summary.className = 'bk-sort__trigger';
    summary.innerHTML = '<span class="bk-sort__label"></span>';
    details.appendChild(summary);
    var label = summary.querySelector('.bk-sort__label');

    var list = document.createElement('ul');
    list.className = 'bk-sort__list';
    Array.prototype.forEach.call(select.options, function (opt) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'bk-sort__option';
      a.setAttribute('role', 'button');
      a.setAttribute('tabindex', '0');
      a.textContent = (opt.textContent || '').trim();
      a.dataset.value = opt.value;
      if (opt.selected) a.setAttribute('aria-current', 'true');
      li.appendChild(a);
      list.appendChild(li);
    });
    details.appendChild(list);

    select.parentNode.insertBefore(details, select);

    function syncLabel() {
      label.textContent = (select.options[select.selectedIndex].textContent || '').trim();
    }
    syncLabel();

    function choose(target) {
      var a = target.closest('.bk-sort__option');
      if (!a) return;
      select.value = a.dataset.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      list.querySelectorAll('.bk-sort__option').forEach(function (b) {
        b.removeAttribute('aria-current');
      });
      a.setAttribute('aria-current', 'true');
      syncLabel();
      details.removeAttribute('open');
    }

    list.addEventListener('click', function (event) {
      choose(event.target);
    });
    list.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        choose(event.target);
      }
    });
  }

  function init() {
    document.querySelectorAll('select.facet-filters__sort').forEach(enhance);
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('details.bk-sort[open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      init();
    });
  }

  function start() {
    init();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
